import {
	FETCH_PROVINCES,
	FETCH_PROVINCES_SUCCESS,
	FETCH_PROVINCES_FAILURE,
	FETCH_DISTRICTS,
	FETCH_DISTRICTS_SUCCESS,
	FETCH_DISTRICTS_FAILURE,
	FETCH_SUBDISTRICTS,
	FETCH_SUBDISTRICTS_SUCCESS,
	FETCH_SUBDISTRICTS_FAILURE,
	FETCH_ZIPCODES,
	FETCH_ZIPCODES_SUCCESS,
	FETCH_ZIPCODES_FAILURE
} from "./addressAction";

const initialState = {
	provinces: [],
	districts: [],
	subDistricts: [],
	zipCodes: [],
	isFetching: false
};

export default function (state = initialState, action) {
	switch (action.type) {
		case FETCH_PROVINCES:
			return {
				...state,
				provinces: [],
				isFetching: true
			};
		case FETCH_PROVINCES_SUCCESS:
			return {
				...state,
				provinces: action.payload,
				isFetching: false
			};
		case FETCH_PROVINCES_FAILURE:
			return {
				...state,
				provinces: [],
				isFetching: false
			};
		case FETCH_DISTRICTS:
			return {
				...state,
				districts: [],
				isFetching: true
			};
		case FETCH_DISTRICTS_SUCCESS:
			return {
				...state,
				districts: action.payload,
				isFetching: false
			};
		case FETCH_DISTRICTS_FAILURE:
			return {
				...state,
				districts: [],
				isFetching: false
			};
		case FETCH_SUBDISTRICTS:
			return {
				...state,
				subDistricts: [],
				isFetching: true
			};
		case FETCH_SUBDISTRICTS_SUCCESS:
			return {
				...state,
				subDistricts: action.payload,
				isFetching: false
			};
		case FETCH_SUBDISTRICTS_FAILURE:
			return {
				...state,
				subDistricts: [],
				isFetching: false
			};
		case FETCH_ZIPCODES:
			return {
				...state,
				zipCodes: [],
				isFetching: true
			};
		case FETCH_ZIPCODES_SUCCESS:
			return {
				...state,
				zipCodes: action.payload,
				isFetching: false
			};
		case FETCH_ZIPCODES_FAILURE:
			return {
				...state,
				zipCodes: [],
				isFetching: false
			};
		default:
			return state;
	}
}
